import { createContext, type PropsWithChildren, useContext } from "react";
import { invariant } from "@exonn/utils";

export function createProvider<Value>(
  defaultValue: Value | null,
  name: string,
) {
  const Context = createContext<Value | null>(defaultValue);

  const Provider = ({
    children,
    value,
  }: PropsWithChildren<{ value: Value }>) => {
    return <Context.Provider value={value}>{children}</Context.Provider>;
  };

  const useContextInner = (): Value => {
    const context = useContext(Context);
    invariant(!!context, `use${name} must be used within provider `);
    return context;
  };

  return {
    useContext: useContextInner,
    Provider,
    Context,
  };
}

export function createProviderWithoutThrowing<Value>(
  defaultValue: Value,
  name: string,
) {
  const Context = createContext<Value>(defaultValue);

  const Provider = ({
    children,
    value,
  }: PropsWithChildren<{ value: Value }>) => {
    return <Context.Provider value={value}>{children}</Context.Provider>;
  };

  const useContextInner = () => {
    return useContext(Context);
  };

  return {
    useContext: useContextInner,
    Provider,
    Context,
  };
}
